import TextTitleCondensed from 'components/TextTitleCondensed'
import React from 'react'

export default function TextTitleCondensedBig (props) {
  return (
    <TextTitleCondensed
      fs='titleBig'
      {...props}
    />
  )
}
